// import OrganizationChart from './OrganizationChart';

export default {
  permissions: ['BasicInformationMenu/ChartMenu'],
  priority: 10,
  // component: OrganizationChart,
  component: load(() => import(/* webpackChunkName: "OrganizationChart" */ './OrganizationChart')),
  name: app.translate('routes.home.Organization Chart'),
  icon: 'domain',
  drawer: true,
};
